<script lang="ts" setup>
import { ref, computed } from "vue";
import AccountLogin from "@/components/account/AccountLogin.vue";
import AccountInfo from "@/components/account/AccountInfo.vue";
import { logoInnax } from "@/services/images";

const tabIndex = ref(null);

const timeCountDown = computed(() => {
  //When subtracting dates the result is given in milliseconds
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;

  const dateNow = new Date();
  const dateParisProof = new Date("2050-01-01");

  return Math.floor((dateParisProof - dateNow) / _MS_PER_DAY);
});
</script>

<template>
  <v-main>
    <div class="account-page">
      <div class="welcome">
        <div class="logo">
          <v-img alt="INNAX Logo" :src="logoInnax" class="image" />
        </div>
        <v-tabs v-model="tabIndex" class="tabToggles" selected-class="active">
          <v-tab value="logon">Aanmelden</v-tab>
          <v-tab value="info">Meer informatie</v-tab>
        </v-tabs>

        <v-tabs-window v-model="tabIndex">
          <v-tabs-window-item value="logon"> <account-login></account-login> </v-tabs-window-item>

          <v-tabs-window-item value="info"> <account-info></account-info> </v-tabs-window-item>
        </v-tabs-window>
      </div>
      <div class="main-image">
        <p>
          Nog <strong>{{ timeCountDown }} dagen</strong> om<br />Paris Proof te halen
        </p>
      </div>
    </div>
  </v-main>
</template>
